export const sendUXSEvent = (name: string) => {
  // oxlint-disable-next-line typescript/no-explicit-any
  if (typeof window !== 'undefined' && (window as any).UXS) {
    // oxlint-disable-next-line typescript/no-explicit-any
    (window as any).UXS.sendEvent(name);
  }
};
